import { render, staticRenderFns } from "./StyleOptionPreview.vue?vue&type=template&id=8b3e3422&scoped=true"
import script from "./StyleOptionPreview.vue?vue&type=script&lang=js"
export * from "./StyleOptionPreview.vue?vue&type=script&lang=js"
import style0 from "./StyleOptionPreview.vue?vue&type=style&index=0&id=8b3e3422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e3422",
  null
  
)

export default component.exports